import { render, staticRenderFns } from "./friendBox.vue?vue&type=template&id=3234d521&scoped=true&"
import script from "./friendBox.vue?vue&type=script&lang=js&"
export * from "./friendBox.vue?vue&type=script&lang=js&"
import style0 from "./friendBox.vue?vue&type=style&index=0&id=3234d521&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3234d521",
  null
  
)

export default component.exports